import {http} from './config';

export default {
    listForAllotment:(allotmentId) => {
        return http.get('api/v1/etapasLoteamentos/listar?forAllotment=true',
                {headers:{'allotment-id': allotmentId}});
    },
    index:(filter = {}, page = 1) => {
        if (filter?.allotment_id === 'selecione') delete filter.allotment_id;
        return http.get(`api/v1/etapasLoteamentos?page=${page}`, {params:{filter}});
    },
    view:(id) => {
        return http.get(`api/v1/etapasLoteamentos/${id}`);
    },
    edit:(id, data) => {
        return http.put(`api/v1/etapasLoteamentos/${id}`, data);
    },
    create:(data) => {
        return http.post(`api/v1/etapasLoteamentos`, data);
    },
    delete:(id) => {
        return http.delete(`api/v1/etapasLoteamentos/${id}`);
    },
}